module.exports = __webpack_public_path__ + "img/Gintama.23928404.jpg";